import { render, staticRenderFns } from "./edit-multi-consent.vue?vue&type=template&id=302fadca&scoped=true&"
import script from "./edit-multi-consent.vue?vue&type=script&lang=js&"
export * from "./edit-multi-consent.vue?vue&type=script&lang=js&"
import style0 from "./edit-multi-consent.vue?vue&type=style&index=0&id=302fadca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302fadca",
  null
  
)

component.options.__file = "edit-multi-consent.vue"
export default component.exports